import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields } from "app/main/std";

import { ClienteList } from "./list/list";
import { ClienteEdit } from "./edit/edit";

export class ClienteCatalogo extends React.Component {
    render() {
        return (
            <div>
                <Route exact path="/catalogos/Cliente" component={ClienteList} />
                <Route path="/catalogos/Cliente/:id" component={ClienteEdit} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/index.tsx